import { ApiResourceFactory } from "../api.resource.factory";
import {  } from "../api.models";
import { CommonHelper } from "../../../helpers/common-helper";
import { ReportExportResult} from '../api.models.ssrs'



export interface ISsrsReportsService {
    getReport(id, state?: any): ng.IPromise<any>;
    generateReport(req): ng.IPromise<ReportExportResult>;
    findText(req, state?: any): ng.IPromise<any>;
}

export class SsrsReportsService implements ISsrsReportsService {

    constructor(private apiResource: ApiResourceFactory) { }

    getReport(id, state: any = {}) {
        const get = this.apiResource.ssrs_reports.query;
        state.request = get({ id: id });
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON();
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message));
    }

    generateReport(req, state: any = {}) {
        var generateReport: ng.resource.IResourceMethod<ng.resource.IResource<ReportExportResult>> = this.apiResource.ssrs_reports["generateReport"];
        state.request = generateReport(req);
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON();
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, null, rej.data.Message))
    }

    findText(req, state: any = {}) {
        var findText: ng.resource.IResourceMethod<ng.resource.IResource<string>> = this.apiResource.ssrs_reports["findstring"];
        state.request = findText(req);
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON();
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}
